import * as api from '../api';
import React, { useState } from 'react';
const emptyForm = {
  name: '',
  jobTitle: '',
  company: '',
  department: '',
  photo: null,
  photoPreview: null
};
function Database({ database, setDatabase }) {
  const presenters = database;

  const setPresenters = async (updater) => {
    const updated = typeof updater === 'function' ? updater(database) : updater;
    setDatabase(updated);
  };
  const [showModal, setShowModal] = useState(false);
  const [editingPresenter, setEditingPresenter] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [filterCompany, setFilterCompany] = useState('');
  const [filterDepartment, setFilterDepartment] = useState('');
  const [searchText, setSearchText] = useState('');
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  const companies = [...new Set(presenters.map(p => p.company))].sort();
  const departments = [...new Set(presenters.map(p => p.department))].sort();

  const filtered = presenters.filter(p => {
    const matchCompany = filterCompany ? p.company === filterCompany : true;
    const matchDept = filterDepartment ? p.department === filterDepartment : true;
    const matchSearch = searchText ? p.name.toLowerCase().includes(searchText.toLowerCase()) : true;
    return matchCompany && matchDept && matchSearch;
  });

  const openAddModal = () => {
    setEditingPresenter(null);
    setForm(emptyForm);
    setShowModal(true);
  };

  const openEditModal = (presenter) => {
    setEditingPresenter(presenter);
    setForm({
      name: presenter.name,
      jobTitle: presenter.jobTitle,
      company: presenter.company,
      department: presenter.department,
      photo: presenter.photo,
      photoPreview: presenter.photo
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingPresenter(null);
    setForm(emptyForm);
  };

  const handleFormChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setForm(prev => ({ ...prev, photo: reader.result, photoPreview: reader.result }));
    };
    reader.readAsDataURL(file);
  };

  const savePresenter = async () => {
    if (!form.name.trim()) return;
    if (editingPresenter) {
      await api.updatePresenter(editingPresenter.id, {
        name: form.name,
        jobTitle: form.jobTitle,
        company: form.company,
        department: form.department,
        photo: form.photo
      });
      setPresenters(prev => prev.map(p =>
        p.id === editingPresenter.id ? { ...p, ...form } : p
      ));
    } else {
      const newPresenter = await api.createPresenter({
        name: form.name,
        jobTitle: form.jobTitle,
        company: form.company,
        department: form.department,
        photo: form.photo
      });
      setPresenters(prev => [...prev, newPresenter]);
    }
    closeModal();
  };

  const deletePresenter = async (id) => {
    await api.deletePresenter(id);
    setPresenters(prev => prev.filter(p => p.id !== id));
    setDeleteConfirm(null);
  };

  return (
    <div>
      <div className="page-header">
        <h1>Database</h1>
        <p>Your presenter database. Add, edit, and filter presenters across all your shows.</p>
      </div>

      {/* Controls Row */}
      <div className="card" style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>

          <input
            type="text"
            placeholder="🔍  Search by name..."
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            style={{
              padding: '8px 12px',
              borderRadius: '6px',
              border: '1px solid #e2e8f0',
              fontSize: '14px',
              width: '220px',
              outline: 'none'
            }}
          />

          <select
            value={filterCompany}
            onChange={e => setFilterCompany(e.target.value)}
            style={{
              padding: '8px 12px',
              borderRadius: '6px',
              border: '1px solid #e2e8f0',
              fontSize: '14px',
              outline: 'none',
              color: filterCompany ? '#1a1a2e' : '#a0aec0'
            }}
          >
            <option value="">All Companies</option>
            {companies.map(c => <option key={c} value={c}>{c}</option>)}
          </select>

          <select
            value={filterDepartment}
            onChange={e => setFilterDepartment(e.target.value)}
            style={{
              padding: '8px 12px',
              borderRadius: '6px',
              border: '1px solid #e2e8f0',
              fontSize: '14px',
              outline: 'none',
              color: filterDepartment ? '#1a1a2e' : '#a0aec0'
            }}
          >
            <option value="">All Departments</option>
            {departments.map(d => <option key={d} value={d}>{d}</option>)}
          </select>

          {(filterCompany || filterDepartment || searchText) && (
            <button
              onClick={() => { setFilterCompany(''); setFilterDepartment(''); setSearchText(''); }}
              style={{
                background: 'none',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                padding: '8px 12px',
                fontSize: '13px',
                color: '#718096',
                cursor: 'pointer'
              }}
            >
              Clear Filters
            </button>
          )}

          <button
            onClick={openAddModal}
            style={{
              marginLeft: 'auto',
              backgroundColor: '#4299e1',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 20px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            + Add Presenter
          </button>
        </div>
      </div>

      {/* Results Count */}
      <p style={{ color: '#718096', fontSize: '13px', marginBottom: '16px' }}>
        Showing {filtered.length} of {presenters.length} presenter{presenters.length !== 1 ? 's' : ''}
      </p>

      {/* Presenter Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '16px' }}>
        {filtered.map(presenter => (
          <div key={presenter.id} className="card" style={{ padding: '0', overflow: 'hidden' }}>

            {/* Photo Area */}
            <div style={{
              width: '100%',
              paddingTop: '100%',
              position: 'relative',
              backgroundColor: '#e2e8f0'
            }}>
              {presenter.photo ? (
                <img
                  src={presenter.photo}
                  alt={presenter.name}
                  style={{
                    position: 'absolute',
                    top: 0, left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              ) : (
                <div style={{
                  position: 'absolute',
                  top: 0, left: 0,
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '64px',
                  color: '#a0aec0'
                }}>
                  👤
                </div>
              )}
            </div>

            {/* Info Area */}
            <div style={{ padding: '14px' }}>
              <p style={{ fontWeight: '700', fontSize: '15px', color: '#1a1a2e', marginBottom: '2px' }}>
                {presenter.name}
              </p>
              <p style={{ fontSize: '13px', color: '#4299e1', marginBottom: '4px' }}>
                {presenter.jobTitle}
              </p>
              <p style={{ fontSize: '12px', color: '#718096' }}>
                {presenter.company} — {presenter.department}
              </p>

              {/* Action Buttons */}
              <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                <button
                  onClick={() => openEditModal(presenter)}
                  style={{
                    flex: 1,
                    padding: '6px',
                    borderRadius: '5px',
                    border: '1px solid #e2e8f0',
                    background: 'white',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#4a5568',
                    fontWeight: '500'
                  }}
                >
                  ✏️ Edit
                </button>
                <button
                  onClick={() => setDeleteConfirm(presenter.id)}
                  style={{
                    flex: 1,
                    padding: '6px',
                    borderRadius: '5px',
                    border: '1px solid #fed7d7',
                    background: '#fff5f5',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#c53030',
                    fontWeight: '500'
                  }}
                >
                  🗑️ Delete
                </button>
              </div>
            </div>
          </div>
        ))}

        {filtered.length === 0 && (
          <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '60px 0', color: '#a0aec0' }}>
            No presenters found. Try adjusting your filters or add a new presenter.
          </div>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      {deleteConfirm && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000
        }}>
          <div className="card" style={{ width: '400px', textAlign: 'center' }}>
            <p style={{ fontSize: '40px', marginBottom: '12px' }}>🗑️</p>
            <h3 style={{ marginBottom: '8px', color: '#1a1a2e' }}>Delete Presenter?</h3>
            <p style={{ color: '#718096', fontSize: '14px', marginBottom: '24px' }}>
              This cannot be undone. The presenter will be removed from the database.
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={() => setDeleteConfirm(null)}
                style={{
                  padding: '10px 24px',
                  borderRadius: '6px',
                  border: '1px solid #e2e8f0',
                  background: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => deletePresenter(deleteConfirm)}
                style={{
                  padding: '10px 24px',
                  borderRadius: '6px',
                  border: 'none',
                  background: '#e53e3e',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600'
                }}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add / Edit Modal */}
      {showModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000
        }}>
          <div className="card" style={{ width: '480px', maxHeight: '90vh', overflowY: 'auto' }}>
            <h2 style={{ marginBottom: '24px', color: '#1a1a2e', fontSize: '20px' }}>
              {editingPresenter ? 'Edit Presenter' : 'Add New Presenter'}
            </h2>

            {/* Photo Upload */}
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <div style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                backgroundColor: '#e2e8f0',
                margin: '0 auto 12px',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '48px',
                color: '#a0aec0'
              }}>
                {form.photoPreview
                  ? <img src={form.photoPreview} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  : '👤'
                }
              </div>
              <label style={{
                display: 'inline-block',
                padding: '6px 16px',
                borderRadius: '6px',
                border: '1px solid #e2e8f0',
                cursor: 'pointer',
                fontSize: '13px',
                color: '#4a5568',
                fontWeight: '500'
              }}>
                📷 Upload Photo
                <input type="file" accept="image/*" onChange={handlePhotoUpload} style={{ display: 'none' }} />
              </label>
            </div>

            {/* Form Fields */}
            {[
              { label: 'Full Name *', field: 'name', placeholder: 'e.g. Jane Smith' },
              { label: 'Job Title', field: 'jobTitle', placeholder: 'e.g. Chief Executive Officer' },
              { label: 'Company', field: 'company', placeholder: 'e.g. Acme Corp' },
              { label: 'Department', field: 'department', placeholder: 'e.g. Marketing' },
            ].map(({ label, field, placeholder }) => (
              <div key={field} style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#4a5568', marginBottom: '6px' }}>
                  {label}
                </label>
                <input
                  type="text"
                  placeholder={placeholder}
                  value={form[field]}
                  onChange={e => handleFormChange(field, e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    borderRadius: '6px',
                    border: '1px solid #e2e8f0',
                    fontSize: '14px',
                    outline: 'none',
                    color: '#1a1a2e'
                  }}
                />
              </div>
            ))}

            {/* Modal Buttons */}
            <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
              <button
                onClick={closeModal}
                style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #e2e8f0',
                  background: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                Cancel
              </button>
              <button
                onClick={savePresenter}
                disabled={!form.name.trim()}
                style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '6px',
                  border: 'none',
                  background: form.name.trim() ? '#4299e1' : '#a0aec0',
                  color: 'white',
                  cursor: form.name.trim() ? 'pointer' : 'not-allowed',
                  fontSize: '14px',
                  fontWeight: '600'
                }}
              >
                {editingPresenter ? 'Save Changes' : 'Add Presenter'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Database;